// NOTE: Product Brand List
export const productBrandList = {
  ok: 1,
  status: 1,
  data: {
    rows: [
      {
        name: 'Brand-2',
      },
      {
        name: 'Brand-1',
      },
      {
        name: 'Brand-3',
      },
    ],
  },
  msg: 'get data is success.',
};

// NOTE: Product Category List
export const productCategoryList = {
  ok: 1,
  status: 1,
  data: {
    rows: [
      {
        id: 53,
        name: 'AS-1',
        badge: 'hot',
        price: 3650,
        short_description:
          'ร่องรีดน้ำขนาดใหญ่ที่แตกต่างกันบริเวณหน้ายาง ช่วยระบายน้ำออกจากหน้ายางได้อย่างรวดเร็วและมีประสิทธิภาพ พร้อมด้วยร่องรีดน้ำขนาดเล็กที่ช่วยระบายน้ำออกจากร่องรีดน้ำหลัก เพื่อการยึดเกาะบนพื้นถนนเปียกเป็นไปอย่างดีเยี่ยมและปลอดภัย',
        product_model: 'AS-1',
        content:
          '<div>\r\r\n<figure>\r\r\n  <img src="https://img5.pic.in.th/file/secure-sv1/Mask-group.png" alt="ภาพตัวอย่าง">\r\r\n  <figcaption>\r\r\n    <h2>Proxes TR1 ยาง Sporty Ultra สมรรถนะสูงรุ่นใหม่ล่าสุด</h2>\r\r\n    <p>ที่นำเอา 2 สุดยอดยางสายพันธุ์สปอร์ต มารวมตัวกัน ด้วยเอกลักษณ์ลายดอกยางแบบไม่สมมาตรจากยาง Proxes Sport และ ลายดอกยางแบบ V-Shape Design จาก Proxes T1R มาออกแบบร่วมกันเป็นดอกลายดอกยางแบบไม่สมมาตรที่เป็นเอกลักษณ์โฉบเฉี่ยวไม่ซ้ำใคร เพื่อการควบคุมที่สมบูรณ์แบบบนทุกพื้นผิว \r\r\nและครั้งแรกของยางรถยนต์กับเทคโนโลยี\r\r\nTIRE WEAR INDICATOR ที่สามารถเช็คได้ว่าเมื่อไหร่ถึงเวลา\r\r\nที่ควรเปลี่ยนยางรถยนต์ครั้งต่อไป</p>\r\r\n  </figcaption>\r\r\n</figure>\r\r\n</div>\r\r\n\r\r\n<div>\r\r\n<figure>\r\r\n  <img src="https://img2.pic.in.th/pic/Mask-group-154e25673e8c6c879.png" alt="ภาพตัวอย่าง">\r\r\n  <figcaption>\r\r\n    <h2>Proxes TR1 ยาง Sporty Ultra สมรรถนะสูงรุ่นใหม่ล่าสุด</h2>\r\r\n    <p>ที่นำเอา 2 สุดยอดยางสายพันธุ์สปอร์ต มารวมตัวกัน ด้วยเอกลักษณ์ลายดอกยางแบบไม่สมมาตรจากยาง Proxes Sport และ ลายดอกยางแบบ V-Shape Design จาก Proxes T1R มาออกแบบร่วมกันเป็นดอกลายดอกยางแบบไม่สมมาตรที่เป็นเอกลักษณ์โฉบเฉี่ยวไม่ซ้ำใคร เพื่อการควบคุมที่สมบูรณ์แบบบนทุกพื้นผิว \r\r\nและครั้งแรกของยางรถยนต์กับเทคโนโลยี\r\r\nTIRE WEAR INDICATOR ที่สามารถเช็คได้ว่าเมื่อไหร่ถึงเวลา\r\r\nที่ควรเปลี่ยนยางรถยนต์ครั้งต่อไป</p>\r\r\n  </figcaption>\r\r\n</figure>\r\r\n</div>',
        tire_width: 225,
        tire_height: 40,
        tire_size: 18,
        attr_brand: 'NANKANG TIRE',
        attr_model: 'AS-1',
        attr_type: 'Tire',
        attr_road: 'ผิวถนนแห้งและผิวถนนเปียก',
        attr_position: 'ขวาหน้า, ซ้ายหน้า, ขวาหลัง, ซ้ายหลัง',
        attr_range: '20000',
        attr_extra_a: 'Traction Groove Edge',
        attr_extra_b: 'High Stiffness Outer Rib',
        attr_extra_c: 'Shallow',
        perf_a: 8,
        perf_b: 10,
        perf_c: 8,
        perf_d: 8,
        perf_e: 8,
        perf_f: 8,
        block_content_a_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-04_result-20250114194725.webp',
        block_content_a_title: 'ร่องตรงรีดน้ำขนาดใหญ่ 4 ร่อง',
        block_content_a_info:
          'เพิ่มการระบายน้ำออกจากหน้ายาง\r\r\nได้อย่างรวดเร็ว ทำให้ประสิทธิภาพบน\r\r\nถนนนเปียกดียิ่งขึ้น',
        block_content_b_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-05-20250108171225.png',
        block_content_b_title: 'ร่องดอกยางขนาดเล็ก',
        block_content_b_info: 'เพิ่มความนุ่มนวลขณะขับขี่จากการวางตำแหน่งร่องยางที่เหมาะสม',
        block_content_c_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-06-20250108171233.png',
        block_content_c_title: 'ร่องดอกยางแบบเกลียว',
        block_content_c_info:
          'ป้องกันการสึกหรอผิดปกติ โดยรักษาผิวสัมผัสของหน้ายาง ให้สัมผัสในระดับเดียวกัน ตลอดทั้งเส้นในขณะรถวิ่งและเบรก',
        block_content_d_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-04_result-20250114194734.webp',
        block_content_d_title: 'ร่องตรงรีดน้ำขนาดใหญ่ 4 ร่อง',
        block_content_d_info:
          'เพิ่มการระบายน้ำออกจากหน้ายาง\r\r\nได้อย่างรวดเร็ว ทำให้ประสิทธิภาพบน\r\r\nถนนนเปียกดียิ่งขึ้น',
        block_content_e_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-05-20250108171245.png',
        block_content_e_title: 'ร่องดอกยางขนาดเล็ก',
        block_content_e_info: 'เพิ่มความนุ่มนวลขณะขับขี่จากการวางตำแหน่งร่องยางที่เหมาะสม',
        block_content_f_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-06-20250108171251.png',
        block_content_f_title: 'ร่องดอกยางแบบเกลียว',
        block_content_f_info:
          'ป้องกันการสึกหรอผิดปกติ โดยรักษาผิวสัมผัสของหน้ายาง ให้สัมผัสในระดับเดียวกัน ตลอดทั้งเส้นในขณะรถวิ่งและเบรก',
        image_a: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/nk1-20241225140920.png',
        image_b: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/pxsp2_right2-%281%29-20250110092651.png',
        image_c: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/pxsp2_front2-%281%29-20250110092712.png',
        image_d: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/pxsp2_left-%281%29-20250110092719.png',
        image_e: null,
        attr_product_a: 'Tire',
        attr_product_b: 'NANKANG TIRE',
        attr_product_c: 'AS-1',
        attr_product_d: null,
        attr_product_e: null,
        attr_product_f: null,
        attr_product_g: null,
        attr_product_h: null,
        attr_product_i: null,
        attr_product_j: null,
        brand_name: 'NANKANG TIRE',
        brand_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/352055214_648286097345606_2032769928131087426_n-20250111162736.png',
      },
      {
        id: 70,
        name: 'AS-2+',
        badge: 'hot',
        price: 3900,
        short_description:
          'ร่องรีดน้ำขนาดใหญ่ที่แตกต่างกันบริเวณหน้ายาง ช่วยระบายน้ำออกจากหน้ายางได้อย่างรวดเร็วและมีประสิทธิภาพ พร้อมด้วยร่องรีดน้ำขนาดเล็กที่ช่วยระบายน้ำออกจากร่องรีดน้ำหลัก เพื่อการยึดเกาะบนพื้นถนนเปียกเป็นไปอย่างดีเยี่ยมและปลอดภัย',
        product_model: 'AS-2+',
        content:
          '<div>\r\r\n<figure>\r\r\n  <img src="https://img5.pic.in.th/file/secure-sv1/Mask-group.png" alt="ภาพตัวอย่าง">\r\r\n  <figcaption>\r\r\n    <h2>Proxes TR1 ยาง Sporty Ultra สมรรถนะสูงรุ่นใหม่ล่าสุด</h2>\r\r\n    <p>ที่นำเอา 2 สุดยอดยางสายพันธุ์สปอร์ต มารวมตัวกัน ด้วยเอกลักษณ์ลายดอกยางแบบไม่สมมาตรจากยาง Proxes Sport และ ลายดอกยางแบบ V-Shape Design จาก Proxes T1R มาออกแบบร่วมกันเป็นดอกลายดอกยางแบบไม่สมมาตรที่เป็นเอกลักษณ์โฉบเฉี่ยวไม่ซ้ำใคร เพื่อการควบคุมที่สมบูรณ์แบบบนทุกพื้นผิว \r\r\nและครั้งแรกของยางรถยนต์กับเทคโนโลยี\r\r\nTIRE WEAR INDICATOR ที่สามารถเช็คได้ว่าเมื่อไหร่ถึงเวลา\r\r\nที่ควรเปลี่ยนยางรถยนต์ครั้งต่อไป</p>\r\r\n  </figcaption>\r\r\n</figure>\r\r\n</div>\r\r\n\r\r\n<div>\r\r\n<figure>\r\r\n  <img src="https://img2.pic.in.th/pic/Mask-group-154e25673e8c6c879.png" alt="ภาพตัวอย่าง">\r\r\n  <figcaption>\r\r\n    <h2>Proxes TR1 ยาง Sporty Ultra สมรรถนะสูงรุ่นใหม่ล่าสุด</h2>\r\r\n    <p>ที่นำเอา 2 สุดยอดยางสายพันธุ์สปอร์ต มารวมตัวกัน ด้วยเอกลักษณ์ลายดอกยางแบบไม่สมมาตรจากยาง Proxes Sport และ ลายดอกยางแบบ V-Shape Design จาก Proxes T1R มาออกแบบร่วมกันเป็นดอกลายดอกยางแบบไม่สมมาตรที่เป็นเอกลักษณ์โฉบเฉี่ยวไม่ซ้ำใคร เพื่อการควบคุมที่สมบูรณ์แบบบนทุกพื้นผิว \r\r\nและครั้งแรกของยางรถยนต์กับเทคโนโลยี\r\r\nTIRE WEAR INDICATOR ที่สามารถเช็คได้ว่าเมื่อไหร่ถึงเวลา\r\r\nที่ควรเปลี่ยนยางรถยนต์ครั้งต่อไป</p>\r\r\n  </figcaption>\r\r\n</figure>\r\r\n</div>',
        tire_width: 225,
        tire_height: 40,
        tire_size: 18,
        attr_brand: 'NANKANG TIRE',
        attr_model: 'AS-2+',
        attr_type: 'Passenger Car',
        attr_road: 'ผิวถนนแห้งและผิวถนนเปียก',
        attr_position: 'ขวาหน้า, ซ้ายหน้า, ขวาหลัง, ซ้ายหลัง',
        attr_range: '20000',
        attr_extra_a: 'ร่องรีดน้ำหลักขนาดใหญ่ 4 ช่อง',
        attr_extra_b: 'ดีไซน์ร่องรีดน้ำหลัก',
        attr_extra_c: 'โครงสร้างของยาง',
        perf_a: 10,
        perf_b: 10,
        perf_c: 9,
        perf_d: 9,
        perf_e: 10,
        perf_f: 8,
        block_content_a_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-03-1_result-20250111022602.webp',
        block_content_a_title: 'ร่องรีดน้ำหลักขนาดใหญ่ 4 ช่อง',
        block_content_a_info:
          'ร่องรีดน้ำหลักขนาดใหญ่ 4 ช่อง ช่วยเพิ่มประสิทธิภาพการระบายน้ำออกจากหน้ายางได้อย่างรวดเร็ว เพิ่มประสิทธิภาพการควบคุมบนพื้นถนนเปียก ได้อย่างดีเยี่ยม',
        block_content_b_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-04-1_result-20250111022605.webp',
        block_content_b_title: 'ดีไซน์ร่องรีดน้ำหลัก',
        block_content_b_info:
          'ดีไซน์ร่องรีดน้ำหลัก ให้มีขนาดความกว้างและความลึกของร่องรีดน้ำ ให้ใหญ่มากยิ่งขึ้น เพื่อช่วยให้การระบายน้ำออกจากหน้ายางได้อย่างรวดเร็วมากยิ่งขึ้น',
        block_content_c_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-05-1_result-20250111022607.webp',
        block_content_c_title: 'โครงสร้างของยาง',
        block_content_c_info:
          'โครงสร้างของยาง และแก้มยางที่แข็งแกร่ง เพิ่อเพิ่มประสิทธิภาพ ในการควบคุมที่แม่นยำ และมั่นคง ให้คุณมั่นใจตลอดการขับขี่',
        block_content_d_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-06-1_result-20250111022609.webp',
        block_content_d_title: 'ผนังของร่องดอกยางออกแบบพิเศษ',
        block_content_d_info:
          'ผนังของร่องดอกยางออกแบบพิเศษ ช่วยจัดระเบียบการไหลของอากาศในร่องดอกยาง ช่วยลดเสียบรบกวนจากยางรถยนต์ขณะขับขี่',
        block_content_e_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-07-1_result-20250111022612.webp',
        block_content_e_title: 'บล็อกดอกยางบริเวณไหล่ยางดีไซน์พิเศษ',
        block_content_e_info:
          'บล็อกดอกยางบริเวณไหล่ยางดีไซน์พิเศษ ช่วยเพิ่มประสิทธิภาพในการระบายน้ำออกจากร่องรีดน้ำหลักได้อย่างรวดเร็ว และช่วยลดเสียงรบกวนจากยางขณะขับขี่ เพิ่มความแข็งแกร่งของไหล่ยาง ให้ควบคุมฉับไว',
        block_content_f_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-03-1_result-20250111022615.webp',
        block_content_f_title: 'ร่องรีดน้ำหลักขนาดใหญ่ 4 ช่อง',
        block_content_f_info:
          'ร่องรีดน้ำหลักขนาดใหญ่ 4 ช่อง ช่วยเพิ่มประสิทธิภาพการระบายน้ำออกจากหน้ายางได้อย่างรวดเร็ว เพิ่มประสิทธิภาพการควบคุมบนพื้นถนนเปียก ได้อย่างดีเยี่ยม',
        image_a: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as-2-plus-cover_result-20250111022620.webp',
        image_b: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as-2-plus-cover_result-20250111022622.webp',
        image_c: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as-2-plus-cover_result-20250111022624.webp',
        image_d: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as-2-plus-cover_result-20250111022626.webp',
        image_e: null,
        attr_product_a: null,
        attr_product_b: 'NANKANG TIRE',
        attr_product_c: 'AS-2+',
        attr_product_d: null,
        attr_product_e: null,
        attr_product_f: null,
        attr_product_g: null,
        attr_product_h: null,
        attr_product_i: null,
        attr_product_j: null,
        brand_name: 'NANKANG TIRE',
        brand_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/352055214_648286097345606_2032769928131087426_n-20250111162736.png',
      },
      {
        id: 71,
        name: 'AS-2+',
        badge: 'hot',
        price: 4000,
        short_description:
          'ที่สุดของเทคโนโลยี ยาง Premium Sport พร้อมด้วยประสิทธิภาพ\r\r\nการยึดเกาะถนนและการควบคุมที่เแม่นยำ ทั้งบนพื้นถนนแห้งและ\r\r\nพื้นถนนเปียก เหมาะสำหรับผู้ที่ต้องการประสิทธิภาพการ\r\r\nยึดเกาะถนนที่ดีเยี่ยม พร้อมกับความนุ่ม..เงียบ ในการขับขี่\r\r\nAS-2+ มั่นใจปลอดภัยทุกการควบคุมบนทุกพื้นผิว เหนือระดับ\r\r\nด้วยความ นุ่มสบาย พร้อมอายุการใช้งานที่ยาวนาน',
        product_model: 'AS-2+',
        content:
          '<div>\r\r\n<figure>\r\r\n  <img src="https://img5.pic.in.th/file/secure-sv1/Mask-group.png" alt="ภาพตัวอย่าง">\r\r\n  <figcaption>\r\r\n    <h2>Proxes TR1 ยาง Sporty Ultra สมรรถนะสูงรุ่นใหม่ล่าสุด</h2>\r\r\n    <p>ที่นำเอา 2 สุดยอดยางสายพันธุ์สปอร์ต มารวมตัวกัน ด้วยเอกลักษณ์ลายดอกยางแบบไม่สมมาตรจากยาง Proxes Sport และ ลายดอกยางแบบ V-Shape Design จาก Proxes T1R มาออกแบบร่วมกันเป็นดอกลายดอกยางแบบไม่สมมาตรที่เป็นเอกลักษณ์โฉบเฉี่ยวไม่ซ้ำใคร เพื่อการควบคุมที่สมบูรณ์แบบบนทุกพื้นผิว \r\r\nและครั้งแรกของยางรถยนต์กับเทคโนโลยี\r\r\nTIRE WEAR INDICATOR ที่สามารถเช็คได้ว่าเมื่อไหร่ถึงเวลา\r\r\nที่ควรเปลี่ยนยางรถยนต์ครั้งต่อไป</p>\r\r\n  </figcaption>\r\r\n</figure>\r\r\n</div>\r\r\n\r\r\n<div>\r\r\n<figure>\r\r\n  <img src="https://img2.pic.in.th/pic/Mask-group-154e25673e8c6c879.png" alt="ภาพตัวอย่าง">\r\r\n  <figcaption>\r\r\n    <h2>Proxes TR1 ยาง Sporty Ultra สมรรถนะสูงรุ่นใหม่ล่าสุด</h2>\r\r\n    <p>ที่นำเอา 2 สุดยอดยางสายพันธุ์สปอร์ต มารวมตัวกัน ด้วยเอกลักษณ์ลายดอกยางแบบไม่สมมาตรจากยาง Proxes Sport และ ลายดอกยางแบบ V-Shape Design จาก Proxes T1R มาออกแบบร่วมกันเป็นดอกลายดอกยางแบบไม่สมมาตรที่เป็นเอกลักษณ์โฉบเฉี่ยวไม่ซ้ำใคร เพื่อการควบคุมที่สมบูรณ์แบบบนทุกพื้นผิว \r\r\nและครั้งแรกของยางรถยนต์กับเทคโนโลยี\r\r\nTIRE WEAR INDICATOR ที่สามารถเช็คได้ว่าเมื่อไหร่ถึงเวลา\r\r\nที่ควรเปลี่ยนยางรถยนต์ครั้งต่อไป</p>\r\r\n  </figcaption>\r\r\n</figure>\r\r\n</div>',
        tire_width: 235,
        tire_height: 40,
        tire_size: 18,
        attr_brand: 'NANKANG TIRE',
        attr_model: 'AS-2+',
        attr_type: 'Passenger Car',
        attr_road: 'ผิวถนนแห้งและผิวถนนเปียก',
        attr_position: 'ขวาหน้า, ซ้ายหน้า, ขวาหลัง, ซ้ายหลัง',
        attr_range: '20000',
        attr_extra_a: 'ร่องรีดน้ำหลักขนาดใหญ่ 4 ช่อง',
        attr_extra_b: 'ดีไซน์ร่องรีดน้ำหลัก',
        attr_extra_c: 'โครงสร้างของยาง',
        perf_a: 10,
        perf_b: 10,
        perf_c: 9,
        perf_d: 9,
        perf_e: 10,
        perf_f: 8,
        block_content_a_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-03-1_result-20250111022834.webp',
        block_content_a_title: 'ร่องรีดน้ำหลักขนาดใหญ่ 4 ช่อง',
        block_content_a_info:
          'ร่องรีดน้ำหลักขนาดใหญ่ 4 ช่อง ช่วยเพิ่มประสิทธิภาพการระบายน้ำออกจากหน้ายางได้อย่างรวดเร็ว เพิ่มประสิทธิภาพการควบคุมบนพื้นถนนเปียก ได้อย่างดีเยี่ยม',
        block_content_b_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-04-1_result-20250111022833.webp',
        block_content_b_title: 'ดีไซน์ร่องรีดน้ำหลัก',
        block_content_b_info:
          'ดีไซน์ร่องรีดน้ำหลัก ให้มีขนาดความกว้างและความลึกของร่องรีดน้ำ ให้ใหญ่มากยิ่งขึ้น เพื่อช่วยให้การระบายน้ำออกจากหน้ายางได้อย่างรวดเร็วมากยิ่งขึ้น',
        block_content_c_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-05-1_result-20250111022829.webp',
        block_content_c_title: 'โครงสร้างของยาง',
        block_content_c_info:
          'โครงสร้างของยาง และแก้มยางที่แข็งแกร่ง เพิ่อเพิ่มประสิทธิภาพ ในการควบคุมที่แม่นยำ และมั่นคง ให้คุณมั่นใจตลอดการขับขี่',
        block_content_d_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-06-1_result-20250111022827.webp',
        block_content_d_title: 'ผนังของร่องดอกยางออกแบบพิเศษ',
        block_content_d_info:
          'ผนังของร่องดอกยางออกแบบพิเศษ ช่วยจัดระเบียบการไหลของอากาศในร่องดอกยาง ช่วยลดเสียบรบกวนจากยางรถยนต์ขณะขับขี่',
        block_content_e_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-07-1_result-20250111022825.webp',
        block_content_e_title: 'บล็อกดอกยางบริเวณไหล่ยางดีไซน์พิเศษ',
        block_content_e_info:
          'บล็อกดอกยางบริเวณไหล่ยางดีไซน์พิเศษ ช่วยเพิ่มประสิทธิภาพในการระบายน้ำออกจากร่องรีดน้ำหลักได้อย่างรวดเร็ว และช่วยลดเสียงรบกวนจากยางขณะขับขี่ เพิ่มความแข็งแกร่งของไหล่ยาง ให้ควบคุมฉับไว',
        block_content_f_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-03-1_result-20250111022823.webp',
        block_content_f_title: 'ร่องรีดน้ำหลักขนาดใหญ่ 4 ช่อง',
        block_content_f_info:
          'ร่องรีดน้ำหลักขนาดใหญ่ 4 ช่อง ช่วยเพิ่มประสิทธิภาพการระบายน้ำออกจากหน้ายางได้อย่างรวดเร็ว เพิ่มประสิทธิภาพการควบคุมบนพื้นถนนเปียก ได้อย่างดีเยี่ยม',
        image_a: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as-2-plus-cover_result-20250111022838.webp',
        image_b: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as-2-plus-cover_result-20250111022841.webp',
        image_c: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as-2-plus-cover_result-20250111022842.webp',
        image_d: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as-2-plus-cover_result-20250111022845.webp',
        image_e: null,
        attr_product_a: null,
        attr_product_b: 'NANKANG TIRE',
        attr_product_c: 'AS-2+',
        attr_product_d: null,
        attr_product_e: null,
        attr_product_f: null,
        attr_product_g: null,
        attr_product_h: null,
        attr_product_i: null,
        attr_product_j: null,
        brand_name: 'NANKANG TIRE',
        brand_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/352055214_648286097345606_2032769928131087426_n-20250111162736.png',
      },
      {
        id: 72,
        name: 'AS-2+',
        badge: 'hot',
        price: 4450,
        short_description:
          'ที่สุดของเทคโนโลยี ยาง Premium Sport พร้อมด้วยประสิทธิภาพ\r\r\nการยึดเกาะถนนและการควบคุมที่เแม่นยำ ทั้งบนพื้นถนนแห้งและ\r\r\nพื้นถนนเปียก เหมาะสำหรับผู้ที่ต้องการประสิทธิภาพการ\r\r\nยึดเกาะถนนที่ดีเยี่ยม พร้อมกับความนุ่ม..เงียบ ในการขับขี่\r\r\nAS-2+ มั่นใจปลอดภัยทุกการควบคุมบนทุกพื้นผิว เหนือระดับ\r\r\nด้วยความ นุ่มสบาย พร้อมอายุการใช้งานที่ยาวนาน',
        product_model: 'AS-2+',
        content:
          '<div>\r\r\n<figure>\r\r\n  <img src="https://img5.pic.in.th/file/secure-sv1/Mask-group.png" alt="ภาพตัวอย่าง">\r\r\n  <figcaption>\r\r\n    <h2>Proxes TR1 ยาง Sporty Ultra สมรรถนะสูงรุ่นใหม่ล่าสุด</h2>\r\r\n    <p>ที่นำเอา 2 สุดยอดยางสายพันธุ์สปอร์ต มารวมตัวกัน ด้วยเอกลักษณ์ลายดอกยางแบบไม่สมมาตรจากยาง Proxes Sport และ ลายดอกยางแบบ V-Shape Design จาก Proxes T1R มาออกแบบร่วมกันเป็นดอกลายดอกยางแบบไม่สมมาตรที่เป็นเอกลักษณ์โฉบเฉี่ยวไม่ซ้ำใคร เพื่อการควบคุมที่สมบูรณ์แบบบนทุกพื้นผิว \r\r\nและครั้งแรกของยางรถยนต์กับเทคโนโลยี\r\r\nTIRE WEAR INDICATOR ที่สามารถเช็คได้ว่าเมื่อไหร่ถึงเวลา\r\r\nที่ควรเปลี่ยนยางรถยนต์ครั้งต่อไป</p>\r\r\n  </figcaption>\r\r\n</figure>\r\r\n</div>\r\r\n\r\r\n<div>\r\r\n<figure>\r\r\n  <img src="https://img2.pic.in.th/pic/Mask-group-154e25673e8c6c879.png" alt="ภาพตัวอย่าง">\r\r\n  <figcaption>\r\r\n    <h2>Proxes TR1 ยาง Sporty Ultra สมรรถนะสูงรุ่นใหม่ล่าสุด</h2>\r\r\n    <p>ที่นำเอา 2 สุดยอดยางสายพันธุ์สปอร์ต มารวมตัวกัน ด้วยเอกลักษณ์ลายดอกยางแบบไม่สมมาตรจากยาง Proxes Sport และ ลายดอกยางแบบ V-Shape Design จาก Proxes T1R มาออกแบบร่วมกันเป็นดอกลายดอกยางแบบไม่สมมาตรที่เป็นเอกลักษณ์โฉบเฉี่ยวไม่ซ้ำใคร เพื่อการควบคุมที่สมบูรณ์แบบบนทุกพื้นผิว \r\r\nและครั้งแรกของยางรถยนต์กับเทคโนโลยี\r\r\nTIRE WEAR INDICATOR ที่สามารถเช็คได้ว่าเมื่อไหร่ถึงเวลา\r\r\nที่ควรเปลี่ยนยางรถยนต์ครั้งต่อไป</p>\r\r\n  </figcaption>\r\r\n</figure>\r\r\n</div>',
        tire_width: 245,
        tire_height: 40,
        tire_size: 18,
        attr_brand: 'NANKANG TIRE',
        attr_model: 'AS-2+',
        attr_type: 'Passenger Car',
        attr_road: 'ผิวถนนแห้งและผิวถนนเปียก',
        attr_position: 'ขวาหน้า, ซ้ายหน้า, ขวาหลัง, ซ้ายหลัง',
        attr_range: '20000',
        attr_extra_a: 'ร่องรีดน้ำหลักขนาดใหญ่ 4 ช่อง',
        attr_extra_b: 'ดีไซน์ร่องรีดน้ำหลัก',
        attr_extra_c: 'โครงสร้างของยาง',
        perf_a: 10,
        perf_b: 10,
        perf_c: 9,
        perf_d: 9,
        perf_e: 10,
        perf_f: 8,
        block_content_a_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-03-1_result-20250111023035.webp',
        block_content_a_title: 'ร่องรีดน้ำหลักขนาดใหญ่ 4 ช่อง',
        block_content_a_info:
          'ร่องรีดน้ำหลักขนาดใหญ่ 4 ช่อง ช่วยเพิ่มประสิทธิภาพการระบายน้ำออกจากหน้ายางได้อย่างรวดเร็ว เพิ่มประสิทธิภาพการควบคุมบนพื้นถนนเปียก ได้อย่างดีเยี่ยม',
        block_content_b_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-04-1_result-20250111023033.webp',
        block_content_b_title: 'ดีไซน์ร่องรีดน้ำหลัก',
        block_content_b_info:
          'ดีไซน์ร่องรีดน้ำหลัก ให้มีขนาดความกว้างและความลึกของร่องรีดน้ำ ให้ใหญ่มากยิ่งขึ้น เพื่อช่วยให้การระบายน้ำออกจากหน้ายางได้อย่างรวดเร็วมากยิ่งขึ้น',
        block_content_c_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-05-1_result-20250111023031.webp',
        block_content_c_title: 'โครงสร้างของยาง',
        block_content_c_info:
          'โครงสร้างของยาง และแก้มยางที่แข็งแกร่ง เพิ่อเพิ่มประสิทธิภาพ ในการควบคุมที่แม่นยำ และมั่นคง ให้คุณมั่นใจตลอดการขับขี่',
        block_content_d_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-06-1_result-20250111023028.webp',
        block_content_d_title: 'ผนังของร่องดอกยางออกแบบพิเศษ',
        block_content_d_info:
          'ผนังของร่องดอกยางออกแบบพิเศษ ช่วยจัดระเบียบการไหลของอากาศในร่องดอกยาง ช่วยลดเสียบรบกวนจากยางรถยนต์ขณะขับขี่',
        block_content_e_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-07-1_result-20250111023026.webp',
        block_content_e_title: 'บล็อกดอกยางบริเวณไหล่ยางดีไซน์พิเศษ',
        block_content_e_info:
          'บล็อกดอกยางบริเวณไหล่ยางดีไซน์พิเศษ ช่วยเพิ่มประสิทธิภาพในการระบายน้ำออกจากร่องรีดน้ำหลักได้อย่างรวดเร็ว และช่วยลดเสียงรบกวนจากยางขณะขับขี่ เพิ่มความแข็งแกร่งของไหล่ยาง ให้ควบคุมฉับไว',
        block_content_f_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as2_web-03-1_result-20250111023024.webp',
        block_content_f_title: 'ร่องรีดน้ำหลักขนาดใหญ่ 4 ช่อง',
        block_content_f_info:
          'ร่องรีดน้ำหลักขนาดใหญ่ 4 ช่อง ช่วยเพิ่มประสิทธิภาพการระบายน้ำออกจากหน้ายางได้อย่างรวดเร็ว เพิ่มประสิทธิภาพการควบคุมบนพื้นถนนเปียก ได้อย่างดีเยี่ยม',
        image_a: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as-2-plus-cover_result-20250111023038.webp',
        image_b: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as-2-plus-cover_result-20250111023040.webp',
        image_c: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as-2-plus-cover_result-20250111023042.webp',
        image_d: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/as-2-plus-cover_result-20250111023044.webp',
        image_e: null,
        attr_product_a: null,
        attr_product_b: 'NANKANG TIRE',
        attr_product_c: 'AS-2+',
        attr_product_d: null,
        attr_product_e: null,
        attr_product_f: null,
        attr_product_g: null,
        attr_product_h: null,
        attr_product_i: null,
        attr_product_j: null,
        brand_name: 'NANKANG TIRE',
        brand_image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/352055214_648286097345606_2032769928131087426_n-20250111162736.png',
      },
    ],
    cur_page: '1',
    per_page: '20',
    total_rows: 36,
    result_rows: 20,
    filters: [],
    sorts: {
      name: 'asc',
    },
    visibility: 'grip',
    category: 'tire',
  },
  msg: 'get data is success',
};

// NOTE: Product Data
export const productData = {
  ok: 1,
  status: 1,
  data: {
    name: 'AS-1',
    badge: 'hot',
    price: 2950,
    short_description:
      'ร่องรีดน้ำขนาดใหญ่ที่แตกต่างกันบริเวณหน้ายาง ช่วยระบายน้ำออกจากหน้ายางได้อย่างรวดเร็วและมีประสิทธิภาพ พร้อมด้วยร่องรีดน้ำขนาดเล็กที่ช่วยระบายน้ำออกจากร่องรีดน้ำหลัก เพื่อการยึดเกาะบนพื้นถนนเปียกเป็นไปอย่างดีเยี่ยมและปลอดภัย',
    product_model: 'AS-1',
    content:
      '<div>\r\r\n<figure>\r\r\n  <img src="https://img5.pic.in.th/file/secure-sv1/Mask-group.png" alt="ภาพตัวอย่าง">\r\r\n  <figcaption>\r\r\n    <h2>Proxes TR1 ยาง Sporty Ultra สมรรถนะสูงรุ่นใหม่ล่าสุด</h2>\r\r\n    <p>ที่นำเอา 2 สุดยอดยางสายพันธุ์สปอร์ต มารวมตัวกัน ด้วยเอกลักษณ์ลายดอกยางแบบไม่สมมาตรจากยาง Proxes Sport และ ลายดอกยางแบบ V-Shape Design จาก Proxes T1R มาออกแบบร่วมกันเป็นดอกลายดอกยางแบบไม่สมมาตรที่เป็นเอกลักษณ์โฉบเฉี่ยวไม่ซ้ำใคร เพื่อการควบคุมที่สมบูรณ์แบบบนทุกพื้นผิว \r\r\nและครั้งแรกของยางรถยนต์กับเทคโนโลยี\r\r\nTIRE WEAR INDICATOR ที่สามารถเช็คได้ว่าเมื่อไหร่ถึงเวลา\r\r\nที่ควรเปลี่ยนยางรถยนต์ครั้งต่อไป</p>\r\r\n  </figcaption>\r\r\n</figure>\r\r\n</div>\r\r\n\r\r\n<div>\r\r\n<figure>\r\r\n  <img src="https://img2.pic.in.th/pic/Mask-group-154e25673e8c6c879.png" alt="ภาพตัวอย่าง">\r\r\n  <figcaption>\r\r\n    <h2>Proxes TR1 ยาง Sporty Ultra สมรรถนะสูงรุ่นใหม่ล่าสุด</h2>\r\r\n    <p>ที่นำเอา 2 สุดยอดยางสายพันธุ์สปอร์ต มารวมตัวกัน ด้วยเอกลักษณ์ลายดอกยางแบบไม่สมมาตรจากยาง Proxes Sport และ ลายดอกยางแบบ V-Shape Design จาก Proxes T1R มาออกแบบร่วมกันเป็นดอกลายดอกยางแบบไม่สมมาตรที่เป็นเอกลักษณ์โฉบเฉี่ยวไม่ซ้ำใคร เพื่อการควบคุมที่สมบูรณ์แบบบนทุกพื้นผิว \r\r\nและครั้งแรกของยางรถยนต์กับเทคโนโลยี\r\r\nTIRE WEAR INDICATOR ที่สามารถเช็คได้ว่าเมื่อไหร่ถึงเวลา\r\r\nที่ควรเปลี่ยนยางรถยนต์ครั้งต่อไป</p>\r\r\n  </figcaption>\r\r\n</figure>\r\r\n</div>',
    tire_width: 192,
    tire_height: 40,
    tire_size: 17,
    attr_brand: 'NANKANG TIRE',
    attr_model: 'AS-1',
    attr_type: 'LT',
    attr_road: 'ผิวถนนแห้งและผิวถนนเปียก',
    attr_position: 'ขวาหน้า, ซ้ายหน้า, ขวาหลัง, ซ้ายหลัง',
    attr_range: '20000',
    attr_extra_a: 'Traction Groove Edge',
    attr_extra_b: 'High Stiffness Outer Rib',
    attr_extra_c: 'Shallow',
    perf_a: 8,
    perf_b: 10,
    perf_c: 8,
    perf_d: 8,
    perf_e: 8,
    perf_f: 8,
    block_content_a_image:
      'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-04_result-20250114194830.webp',
    block_content_a_title: 'ร่องตรงรีดน้ำขนาดใหญ่ 4 ร่อง',
    block_content_a_info:
      'เพิ่มการระบายน้ำออกจากหน้ายาง\r\r\nได้อย่างรวดเร็ว ทำให้ประสิทธิภาพบน\r\r\nถนนนเปียกดียิ่งขึ้น',
    block_content_b_image:
      'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-05-20250108171225.png',
    block_content_b_title: 'ร่องดอกยางขนาดเล็ก',
    block_content_b_info: 'เพิ่มความนุ่มนวลขณะขับขี่จากการวางตำแหน่งร่องยางที่เหมาะสม',
    block_content_c_image:
      'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-06-20250108171233.png',
    block_content_c_title: 'ร่องดอกยางแบบเกลียว',
    block_content_c_info:
      'ป้องกันการสึกหรอผิดปกติ โดยรักษาผิวสัมผัสของหน้ายาง ให้สัมผัสในระดับเดียวกัน ตลอดทั้งเส้นในขณะรถวิ่งและเบรก',
    block_content_d_image:
      'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-04_result-20250114194833.webp',
    block_content_d_title: 'ร่องตรงรีดน้ำขนาดใหญ่ 4 ร่อง',
    block_content_d_info:
      'เพิ่มการระบายน้ำออกจากหน้ายาง\r\r\nได้อย่างรวดเร็ว ทำให้ประสิทธิภาพบน\r\r\nถนนนเปียกดียิ่งขึ้น',
    block_content_e_image:
      'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-05-20250108171245.png',
    block_content_e_title: 'ร่องดอกยางขนาดเล็ก',
    block_content_e_info: 'เพิ่มความนุ่มนวลขณะขับขี่จากการวางตำแหน่งร่องยางที่เหมาะสม',
    block_content_f_image:
      'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/proxes-cr1_web-06-20250108171251.png',
    block_content_f_title: 'ร่องดอกยางแบบเกลียว',
    block_content_f_info:
      'ป้องกันการสึกหรอผิดปกติ โดยรักษาผิวสัมผัสของหน้ายาง ให้สัมผัสในระดับเดียวกัน ตลอดทั้งเส้นในขณะรถวิ่งและเบรก',
    image_a: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/nk1-20241225140920.png',
    image_b: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/pxsp2_right2-%281%29-20250110092651.png',
    image_c: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/pxsp2_front2-%281%29-20250110092712.png',
    image_d: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/pxsp2_left-%281%29-20250110092719.png',
    image_e: null,
    attr_product_a: null,
    attr_product_b: 'NANKANG TIRE',
    attr_product_c: 'AS-1',
    attr_product_d: null,
    attr_product_e: null,
    attr_product_f: null,
    attr_product_g: null,
    attr_product_h: null,
    attr_product_i: null,
    attr_product_j: null,
    brand_name: 'NANKANG TIRE',
    brand_image:
      'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/352055214_648286097345606_2032769928131087426_n-20250111162736.png',
  },
  msg: 'get data is success.',
};

// NOTE: Product Id by DecInc
export const productIdData = {
  ok: 1,
  status: 1,
  data: {
    id: 45,
  },
  msg: 'get data is success.',
};

// NOTE: DataSearchBlock
export const dataSearchBlock = {
  ok: 1,
  status: 1,
  data: {
    rows: [
      {
        value: 175,
      },
      {
        value: 185,
      },
      {
        value: 192,
      },
      {
        value: 195,
      },
      {
        value: 205,
      },
      {
        value: 215,
      },
      {
        value: 225,
      },
      {
        value: 235,
      },
      {
        value: 245,
      },
      {
        value: 255,
      },
      {
        value: 265,
      },
      {
        value: 285,
      },
    ],
  },
  msg: 'get data is success.',
};

// NOTE: banners List
export const banners = {
  ok: 1,
  status: 1,
  data: {
    rows: [
      {
        title: 'HOOME1',
        pc_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/banner-20250110224720.png',
        mobile_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/grip_mainmbpx_a-20250114221733.jpg',
        link_url: null,
        position: 1,
      },
      {
        title: 'HOME2',
        pc_image_url:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/aw_gripbanner1900x500mb-20250114221814-20250116173124.jpg',
        mobile_image_url:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/aw_gripbanner1900x500mb-20250114221814-20250116170140.jpg',
        link_url: null,
        position: 2,
      },
    ],
  },
  msg: 'get data is success.',
};

// NOTE: popups List
export const popups = {
  ok: 1,
  status: 1,
  data: {
    rows: [
      {
        title: 'POPUP1',
        pc_image_url:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/popup-grip-1-20250108172219-20250116212515.png',
        mobile_image_url:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/popup-grip-1-20250108172219resize_mobile-20250116160104.png',
        link_url: null,
        position: 1,
      },
      {
        title: 'POPUP02',
        pc_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/popup-grip-2-20250108172328.jpg',
        mobile_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/popup-grip-2-20250108172328.jpg',
        link_url: null,
        position: 0,
      },
    ],
  },
  msg: 'get data is success.',
};

// NOTE: Promotion List
export const promotionList = {
  ok: 1,
  status: 1,
  data: {
    rows: [
      {
        id: 6,
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/cat2-20241213151847.jpg',
        title: 'Post Title',
        excerpt:
          'เด็กนิตโตะรักรถรีบดีล ❤️ เมื่อลูกค้า NITTO Tire ซื้อประกันภัยรถยนต์ประเภทชั้น 1, 2+ และ EV กับธนชาตประกันภัย รับส่วนลดสุดพิเศษ พร้อมดีลเด็ดถึง 3 ต่อ',
      },
      {
        id: 6,
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/cat2-20241213151847.jpg',
        title: 'Post Title',
        excerpt:
          'เด็กนิตโตะรักรถรีบดีล ❤️ เมื่อลูกค้า NITTO Tire ซื้อประกันภัยรถยนต์ประเภทชั้น 1, 2+ และ EV กับธนชาตประกันภัย รับส่วนลดสุดพิเศษ พร้อมดีลเด็ดถึง 3 ต่อ',
      },
      {
        id: 6,
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/cat2-20241213151847.jpg',
        title: 'Post Title',
        excerpt:
          'เด็กนิตโตะรักรถรีบดีล ❤️ เมื่อลูกค้า NITTO Tire ซื้อประกันภัยรถยนต์ประเภทชั้น 1, 2+ และ EV กับธนชาตประกันภัย รับส่วนลดสุดพิเศษ พร้อมดีลเด็ดถึง 3 ต่อ',
      },
    ],
  },
  msg: 'get data is success.',
};
// NOTE: Promotion Detail
export const promotionData = {
  ok: 1,
  status: 1,
  data: {
    cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/cat2-20241213151847.jpg',
    header_share_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/tb4-20241213151847.jpg',
    title: 'Post Title',
    excerpt: 'Excerpt',
    content_html: '<p>เนื้อหาของบทความ</p>',
    seo_page_title: 'Page Title',
    seo_meta_description: 'Meta Description ค าบรรยายกลุ่มความบทความเพื่อเสริมการค้นหา',
    seo_url: 'Url',
  },
  msg: 'get data is success.',
};

// NOTE: News List
export const newsList = {
  ok: 1,
  status: 1,
  data: {
    cur_page: '1',
    per_page: '9',
    rows: [
      {
        id: 28,
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/news-20250115131312.png',
        title:
          'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง  ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
        excerpt:
          'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง  ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
      },
      {
        id: 26,
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/news-%287%29-20250108230258.png',
        title:
          'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง  ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
        excerpt:
          'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
      },
      {
        id: 25,
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/news-%286%29-20250108230118.png',
        title:
          'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง  ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
        excerpt:
          'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง  ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
      },
      {
        id: 24,
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/news-%285%29-20250108230018.png',
        title:
          'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง  ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
        excerpt:
          'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
      },
      {
        id: 23,
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/news-%284%29-20250108225911.png',
        title:
          'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง  ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
        excerpt:
          'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
      },
      {
        id: 22,
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/news-%283%29-20250108225656.png',
        title:
          'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง  ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
        excerpt:
          'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
      },
      {
        id: 20,
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/news-%281%29-20250108225354.png',
        title:
          'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง  ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
        excerpt:
          'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง  ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
      },
      {
        id: 19,
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/news-20250108235426.png',
        title: 'เปิดแล้ววันนี้!! GRIP SC AUTO TIRE ขอนแก่นยกขบวนความคุ้มค่า ปลอดภัย แบบจัดเต็ม',
        excerpt:
          'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง  ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
      },
      {
        id: 4,
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/0060-670x340-20241225164638.jpg',
        title:
          'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง  ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
        excerpt:
          'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
      },
    ],
    total_rows: 9,
    result_rows: 9,
    filters: [],
    sorts: {
      id: 'desc',
    },
  },
  msg: 'get data is success.',
};

// NOTE: News Detail
export const newsData = {
  ok: 1,
  status: 1,
  data: {
    cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/news-20250115131312.png',
    header_share_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/news-20250115131313.png',
    title:
      'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง  ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
    excerpt:
      'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำ เข้าและจัดจำหน่ายยาง โตโย ไทร์ ยาง นิตโตะ ไทร์ ยางนันกัง  ไทร์ และศูนย์บริการยางรถยนต์ ครบวงจร “GRIP”',
    content_html:
      '<p>เปิดแล้ววันนี้ GRIP SC AUTO TIRE ฉลองเปิดศูนย์บริการสาขาแรกในจังหวัดขอนแก่น พร้อมจัดโปรโมชั่นโดนใจยกขบวนความคุ้มค่า และความปลอดภัยแบบจัดเต็มให้กับชาวขอนแก่น โดยมีนายอภิชัย ตั้งวงศ์ศิริ กรรมการผู้จัดการ บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ผู้นำเข้า และจัดจำหน่ายยางโตโย ไทร์ , ยางนิตโตะ ไทร์ และยางนันกัง ไทร์ อย่างเป็นทางการในประเทศไทย เข้าร่วมแสดงความยินดี ศูนย์บริการยางรถยนต์ GRIP SC AUTO TIRE จ.ขอนแก่น จัดจำหน่ายยางโตโย ไทร์ , ยางนิตโตะ ไทร์ และยางนันกัง ไทร์ พร้อมให้บริการ ช่วงล่าง-ตั้งศูนย์ถ่วงล้อ และจัดจำหน่ายล้อแม็กซ์สำหรับรถยนต์และรถกระบะมากมายหลายรุ่น หลากยี่ห้อ และหลายขนาด พร้อมด้วยทีมงานช่างมืออาชีพ ที่ให้คำปรึกษาและบริการลูกค้าทุกท่านอย่างเต็มที่ จึงมั่นใจได้ว่าเมื่อเข้ามาใช้บริการที่ Grip ท่านจะได้รับ การบริการที่ดีและได้มาตรฐาน ฉลองเปิดสาขาใหม่ให้คุณมากกว่ากับฟรีแพ็คเกจเพิ่มความปลอดภัย ทุกการเดินทาง ด้วยโปรโมชั่นเอาใจ ผู้ใช้รถ เพียงเปลี่ยนยางโตโย ไทร์ ยางนิตโตะ ไทร์ หรือยางนันกัง ไทร์ รับโปรโมชั่นเติมลมไนโตรเจนฟรีตลอดการใช้งาน พร้อมรับบริการ ตั้งศูนย์ ถ่วงล้อฟรีทุกๆ 10,000 กิโลเมตร จำนวน 5 ครั้ง ฟรีค่าแรง ฟรีปะยาง พร้อมตรวจเช็คสภาพยางตลอดอายุการใช้งานฟรี!! สำหรับผู้ใช้รถชาวขอนแก่นหรือพื้นที่ใกล้เคียงที่สนใจสามารถเข้าบริการได้ทุกวัน </p>',
    seo_page_title:
      'สอบถามรายละเอียดเพิ่มเติมได้ที่เบอร์ติดต่อ 091-7491555 หรือ https://www.gripthailand.com และ facebook : GripThailand',
    seo_meta_description:
      '#GripThailand #เรื่องยางครบจบทุกบริการ #ปัญหารถเป็นเรื่องจิ๊บๆถ้าเข้ากริพแถวบ้าน #ToyoTiresThailand#โปรโมชัน #โปรเด็ด #โปรผ่อน #ยางหนึบ #ยางนุ่มเงียบ#ยางซิ่ง #ยางพรีเมียม #ยางสปอร์ต #ยางลุย #ยางออฟโรด',
    seo_url: 'cปผ',
  },
  msg: 'get data is success.',
};

// NOTE: video List
export const videoList = {
  ok: 1,
  status: 1,
  data: {
    rows: [
      {
        id: 12,
        cover_image_url:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/vdo-20241225144948-20250108231110.png',
        title: '5 จุดที่ต้องใส่ใจดูแลรถอย่างไร ส่งท้ายหน้าฝน',
        excerpt:
          'ฤดูเก่ากำลังผ่านไป ฤดูใหม่ก็กำลังเข้ามาแล้ว ผู้ขับขี่รถยนต์จะมีวิธีดูแลรถส่งท้ายหน้าฝน พร้อมต้อนรับลบหนาวได้อย่างไรบ้าง?',
        youtube_share_link: 'https://youtu.be/xhBqLvk_Szc?si=jEJLx-BVlbPGLR57',
        seo_page_title: null,
        seo_meta_description: null,
        seo_url: null,
      },
      {
        id: 11,
        cover_image_url:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/vdo-20241225144948-20250108231110.png',
        title: '5 จุดที่ต้องใส่ใจดูแลรถอย่างไร ส่งท้ายหน้าฝน',
        excerpt:
          'ฤดูเก่ากำลังผ่านไป ฤดูใหม่ก็กำลังเข้ามาแล้ว ผู้ขับขี่รถยนต์จะมีวิธีดูแลรถส่งท้ายหน้าฝน พร้อมต้อนรับลบหนาวได้อย่างไรบ้าง?',
        youtube_share_link: 'https://youtu.be/xhBqLvk_Szc?si=jEJLx-BVlbPGLR57',
        seo_page_title: null,
        seo_meta_description: null,
        seo_url: null,
      },
      {
        id: 10,
        cover_image_url:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2025-01/vdo-20241225144948-20250108231110.png',
        title: '5 จุดที่ต้องใส่ใจดูแลรถอย่างไร ส่งท้ายหน้าฝน',
        excerpt:
          'ฤดูเก่ากำลังผ่านไป ฤดูใหม่ก็กำลังเข้ามาแล้ว ผู้ขับขี่รถยนต์จะมีวิธีดูแลรถส่งท้ายหน้าฝน พร้อมต้อนรับลบหนาวได้อย่างไรบ้าง?',
        youtube_share_link: 'https://youtu.be/xhBqLvk_Szc?si=jEJLx-BVlbPGLR57',
        seo_page_title: null,
        seo_meta_description: null,
        seo_url: null,
      },
    ],
  },
  msg: 'get data is success.',
};

// NOTE: video Detail
export const videoData = {
  ok: 1,
  status: 1,
  data: {
    cover_image_url: null,
    header_share_image_url: null,
    title: 'test-1',
    excerpt: 'test-2',
    youtube_embed:
      '<iframe width="560" height="315"src="https://www.youtube.com/embed/xhBqLvk_Szc?si=ABnBcsKk8_kOIzxO" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin"allowfullscreen></iframe>',
    seo_page_title: null,
    seo_meta_description: null,
    seo_url: null,
  },
  msg: 'get data is success.',
};

// NOTE: branch
export const branchList = {
  ok: 1,
  status: 1,
  data: {
    rows: [
      {
        id: 45,
        name: 'GRIP By KEN ออโต้ไทร์',
        code: 'GRIP0014',
        tel: '0965566329',
        email: 'gripby.kenautotire@gmail.com',
        address:
          '181/1 ถนนกาญจนาภิเษก แขวงท่าข้าม เขตบางขุนเทียน\r\r\r\r\r\nกรุงเทพฯ 10150\r\r\r\r\r\nโทร : 096-556-6329 , 065-142-9165',
        location_lat: '13.62659807',
        location_lng: '100.45381007',
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/grip-shop-20241224175238.png',
      },
      {
        id: 43,
        name: 'GRIP By จรัส ล้อแม็ก เซอร์วิส',
        code: 'GRIP0012',
        tel: '0965566329',
        email: 'gripby.kenautotire@gmail.com',
        address: '404 ถนนเทพรักษ์ แขวงท่าแร้ง เขตบางเขน\n\n\n\nกรุงเทพฯ 10230\n\n\n\n\nโทร : 091-112-1114',
        location_lat: '13.87755550',
        location_lng: '100.63397480',
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/grip-shop-20241224175238.png',
      },
      {
        id: 36,
        name: 'GRIP By ทีเอส ไทร์',
        code: 'GRIP0005',
        tel: '061-470-4333',
        email: 'grip.ts5353@gmail.com',
        address: '30/2 หมู่ที่ 7  ตำบลพันท้ายนรสิงห์ อำเภอเมืองสมุทรสาคร จังหวัดสมุทรสาคร 74000',
        location_lat: '13.57146726',
        location_lng: '100.34849063',
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/26219-copy-20241225224153.webp',
      },
      {
        id: 39,
        name: 'GRIP By พรสวรรค์ ศูนย์ล้อ',
        code: 'GRIP0008',
        tel: '0892451162',
        email: 'gripby.psw@gmail.com',
        address: '385/21-23 หมู่ 10  ตำบลนครสวรรค์ตก   อำเภอเมืองนครสวรรค์ จังหวัดนครสวรรค์ 60000',
        location_lat: '15.71939108',
        location_lng: '100.11741633',
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/psw-20241225221540.jpg',
      },
      {
        id: 40,
        name: 'GRIP By อาร์ เอส คาร์เซอร์วิส',
        code: 'GRIP0009',
        tel: '086-481-6382',
        email: 'rs_carservice@hotmail.co.th',
        address: '277/8 หมู่ 2  ตำบลพะวง อำเภอเมืองสงขลา จังหวัดสงขลา 90100',
        location_lat: '7.13389320',
        location_lng: '100.57398440',
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/img_7627-20241225210412.jpg',
      },
      {
        id: 41,
        name: 'GRIP By เค.ออโต้',
        code: 'GRIP0010',
        tel: '021168939',
        email: 'gripby.kauto@gmail.com',
        address:
          '383 ซอยรามอินทรา 35 ถนนรามอินทรา แขวงอนุสาวรีย์ เขตบางเขน\r\r\r\r\r\nกรุงเทพฯ 10220\r\r\r\r\r\nโทร : 02-116-8939',
        location_lat: '13.85856083',
        location_lng: '100.62598204',
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/grip-shop-20241224175724.png',
      },
      {
        id: 44,
        name: 'GRIP By เรซสเปกวีล',
        code: 'GRIP0013',
        tel: '0944978345',
        email: 'gripby.racespecwheel@gmail.com',
        address:
          '580,582,584,586 ถนนพระรามที่ 2 แขวงแสมดำ เขตบางขุนเทียน กรุงเทพฯ 10150 \r\r\r\r\r\nโทร : 094-497-8345 , 087-519-4900',
        location_lat: '13.63375750',
        location_lng: '100.40051220',
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/grip-shop-20241224175027.png',
      },
      {
        id: 42,
        name: 'GRIP By เอกรุ่งเรืองออโต้ไทร์',
        code: 'GRIP0011',
        tel: '955156133',
        email: 'gripby.aekrungruang@gmail.com',
        address:
          '8/191-192 ถนนกาญจนาภิเษก แขวงบางแค เขตบางแค\r\r\r\r\r\nกรุงเทพฯ 10160\r\r\r\r\r\nโทร : 095-515-6133 , 089-110-1719',
        location_lat: '13.69391310',
        location_lng: '100.40707110',
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/grip-shop-20241224175558.png',
      },
      {
        id: 37,
        name: 'GRIP By เอกสยามออโต้แม็กซ์',
        code: 'GRIP0006',
        tel: '087-678-1448',
        email: 'gripby.akesiamautomax@gmail.com',
        address: '1,3,5 ถนนจิตบำรุง ตำบลในเมือง อำเภอเมืองสุรินทร์ จังหวัดสุรินทร์ 32000',
        location_lat: '14.89006980',
        location_lng: '103.49704740',
        cover_image_url:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/%E0%B8%A0%E0%B8%B2%E0%B8%9E%E0%B8%A3%E0%B9%89%E0%B8%B2%E0%B8%99_result-20241225224416.webp',
      },
    ],
    cur: '1',
    per: '9',
    result_total: 9,
    row_total: 10,
  },
  msg: 'get data is success.',
};

export const branchListByName = {
  ok: 1,
  status: 1,
  data: {
    rows: [
      {
        id: 45,
        name: 'GRIP By KEN ออโต้ไทร์',
        code: 'GRIP0014',
        tel: '0965566329',
        email: 'gripby.kenautotire@gmail.com',
        address:
          '181/1 ถนนกาญจนาภิเษก แขวงท่าข้าม เขตบางขุนเทียน\r\r\r\r\r\nกรุงเทพฯ 10150\r\r\r\r\r\nโทร : 096-556-6329 , 065-142-9165',
        location_lat: '13.62659807',
        location_lng: '100.45381007',
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/grip-shop-20241224175238.png',
      },
      {
        id: 39,
        name: 'GRIP By พรสวรรค์ ศูนย์ล้อ',
        code: 'GRIP0008',
        tel: '0892451162',
        email: 'gripby.psw@gmail.com',
        address: '385/21-23 หมู่ 10  ตำบลนครสวรรค์ตก   อำเภอเมืองนครสวรรค์ จังหวัดนครสวรรค์ 60000',
        location_lat: '15.71939108',
        location_lng: '100.11741633',
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/psw-20241225221540.jpg',
      },
    ],
    cur: '1',
    per: '9',
    result_total: 9,
    row_total: 10,
  },
  msg: 'get data is success.',
};

export const branchListByLocation = {
  ok: 1,
  status: 1,
  data: {
    rows: [
      {
        id: 45,
        name: 'GRIP By KEN ออโต้ไทร์',
        code: 'GRIP0014',
        tel: '0965566329',
        email: 'gripby.kenautotire@gmail.com',
        address:
          '181/1 ถนนกาญจนาภิเษก แขวงท่าข้าม เขตบางขุนเทียน\r\r\r\r\r\nกรุงเทพฯ 10150\r\r\r\r\r\nโทร : 096-556-6329 , 065-142-9165',
        location_lat: '13.62659807',
        location_lng: '100.45381007',
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/grip-shop-20241224175238.png',
      },
      {
        id: 43,
        name: 'GRIP By จรัส ล้อแม็ก เซอร์วิส',
        code: 'GRIP0012',
        tel: '0965566329',
        email: 'gripby.kenautotire@gmail.com',
        address: '404 ถนนเทพรักษ์ แขวงท่าแร้ง เขตบางเขน\n\n\n\nกรุงเทพฯ 10230\n\n\n\n\nโทร : 091-112-1114',
        location_lat: '13.87755550',
        location_lng: '100.63397480',
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/grip-shop-20241224175238.png',
      },
      {
        id: 36,
        name: 'GRIP By ทีเอส ไทร์',
        code: 'GRIP0005',
        tel: '061-470-4333',
        email: 'grip.ts5353@gmail.com',
        address: '30/2 หมู่ที่ 7  ตำบลพันท้ายนรสิงห์ อำเภอเมืองสมุทรสาคร จังหวัดสมุทรสาคร 74000',
        location_lat: '13.57146726',
        location_lng: '100.34849063',
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/26219-copy-20241225224153.webp',
      },
      {
        id: 39,
        name: 'GRIP By พรสวรรค์ ศูนย์ล้อ',
        code: 'GRIP0008',
        tel: '0892451162',
        email: 'gripby.psw@gmail.com',
        address: '385/21-23 หมู่ 10  ตำบลนครสวรรค์ตก   อำเภอเมืองนครสวรรค์ จังหวัดนครสวรรค์ 60000',
        location_lat: '15.71939108',
        location_lng: '100.11741633',
        cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/psw-20241225221540.jpg',
      },
    ],
    cur: '1',
    per: '9',
    result_total: 9,
    row_total: 10,
  },
  msg: 'get data is success.',
};

export const branchData = {
  ok: 1,
  status: 1,
  data: {
    name: 'GRIP By KEN ออโต้ไทร์',
    code: 'GRIP0014',
    tel: '0965566329',
    email: 'gripby.kenautotire@gmail.com',
    address:
      '181/1 ถนนกาญจนาภิเษก แขวงท่าข้าม เขตบางขุนเทียน\r\r\r\r\r\nกรุงเทพฯ 10150\r\r\r\r\r\nโทร : 096-556-6329 , 065-142-9165',
    working_days: {
      friday: {
        open: '08:30',
        close: '17:30',
        enable: 0,
      },
      monday: {
        open: '08:30',
        close: '17:30',
        enable: 0,
      },
      sunday: {
        open: '08:30',
        close: '17:30',
        enable: 0,
      },
      tuesday: {
        open: '08:30',
        close: '17:30',
        enable: 0,
      },
      saturday: {
        open: '08:30',
        close: '17:30',
        enable: 1,
      },
      thursday: {
        open: '08:30',
        close: '17:30',
        enable: 0,
      },
      wednesday: {
        open: '08:30',
        close: '17:30',
        enable: 0,
      },
    },
    location_lat: '13.62659807',
    location_lng: '100.45381007',
    youtube_link: null,
    facebook_link: null,
    instagram_link: null,
    tiktok_link: null,
    cover_image_url: 'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/grip-shop-20241224175238.png',
  },
  msg: 'get data is success.',
};

export const menuMock = {
  ok: 1,
  status: 1,
  data: {
    rows: [
      {
        id: 1,
        name: 'Tire',
        image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/screenshot-2024-12-25-133704-20241225133801.png',
        key_name: 'tire',
      },
      {
        id: 2,
        name: 'Lubricants',
        image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/screenshot-2024-12-25-133811-20241225133828.png',
        key_name: 'non-tire',
      },
      {
        id: 4,
        name: 'Brake',
        image:
          'https://pub-blob.s3.ap-southeast-1.amazonaws.com/2024-12/screenshot-2024-12-25-133839-20241225133857.png',
        key_name: 'non-tire',
      },
    ],
  },
  msg: 'get data is success.',
};
